export default __webpack_public_path__ + "static/media/img-5.5c306334.png";